import Swiper, {Navigation, Thumbs} from 'swiper';

const galleriesMain = document.querySelectorAll('.gallery-main');
const galleriesThumb = document.querySelectorAll('.gallery-thumb');
const btnNext = document.querySelectorAll('.swiper-button-next-gallery');
const btnPrev = document.querySelectorAll('.swiper-button-prev-gallery');

for (let i = 0; i < galleriesMain.length; i++ ) {

  galleriesThumb[i].classList.add('gallery-thumb-' + i);
  galleriesMain[i].classList.add('gallery-main-' + i);
  btnNext[i].classList.add('swiper-button-next-gallery-' + i);
  btnPrev[i].classList.add('swiper-button-prev-gallery-' + i);

  var sl2 = new Swiper(".gallery-thumb-" + i, {
    loop: false,
    spaceBetween: 24,
    slidesPerView: 4,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true
  });
  new Swiper(".gallery-main-" + i, {
    modules: [Navigation, Thumbs ],
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-button-next-gallery-" + i,
      prevEl: ".swiper-button-prev-gallery-" + i,
    },
    thumbs: {
      swiper: sl2
    },
  });

}

